








































import { Component, Vue } from 'vue-property-decorator';
import { AngularAlexMap } from '@/angular/angular-alex-map';
import MapLeftSidebar from '@/components/MapLeftSidebar.vue';
import pointsOfInterestService from '@/services/PointsOfInterestService';
import { Point } from '@/models/point';
import { EventBus } from '@/utils/EventBus';
import { Config } from '@/utils/Config';
import { dispatchWindowEvent } from '@/utils/Helpers';
import { PointOfInterest } from '@/models/pointOfInterest';
import { Consoler } from '@/utils/Consoler';
import { appName } from '@/angular/angular-alex-map';

@Component({
  components: {
    MapLeftSidebar
  }
})
export default class Map extends Vue {
  private showSidebarRight: boolean = false;
  private selectedPoint: Point | null = null;
  private isFullScreen: boolean = false;
  private isLoading: boolean = false;
  private errorLoading: boolean = false;

  private pointsOfInterest: PointOfInterest[] = [];

  private get points(): Point[] {
    return this.pointsOfInterest.map(pointOfInterest => ({
      coordinates: [pointOfInterest.longitude, pointOfInterest.latitude],
      projection: 'EPSG:3006',
      pointOfInterest
    }));
  }

  private created(): void {
    EventBus.$on(Config.MapSetFullScreenEvent, this.onSetFullScreen);
    EventBus.$on(Config.MapSetShowSidebarRightEvent, this.onShowSidebarRight);
    EventBus.$on(Config.MapPointSelectedEvent, this.onPointSelected);
  }

  private mounted() {
    this.initialize();
  }

  private beforeDestroy(): void {
    EventBus.$off(Config.MapSetFullScreenEvent, this.onSetFullScreen);
    EventBus.$off(Config.MapSetShowSidebarRightEvent, this.onShowSidebarRight);
    EventBus.$off(Config.MapPointSelectedEvent, this.onPointSelected);

    const angularDirective = this.$el.querySelector('#angularDirective');
    if (angularDirective) {
      angularDirective.dispatchEvent(new Event('App-Destroy'));
    }
  }

  private initialize() {
    this.isLoading = true;
    this.errorLoading = false;

    this.bootstrapAngular();
    this.loadPointsOfInterest()
      .then(() => {
        setTimeout(() => {
          EventBus.$emit(Config.MapSetPointsEvent, this.points);
        });
      })
      .catch(() => {
        this.errorLoading = true;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  private bootstrapAngular(): void {
    AngularAlexMap.createAngularApp();

    window.angular.element(() => {
      window.angular.bootstrap(document, [appName]);
    });
  }

  private loadPointsOfInterest(): Promise<any> {
    return pointsOfInterestService
      .getPointsOfInterest()
      .then(pointsOfInterest => {
        this.pointsOfInterest = pointsOfInterest;
      })
      .catch(error => {
        Consoler.debugWarn(
          'Something went wrong loading points of interest',
          error
        );
        return Promise.reject(error);
      });
  }

  private onSetFullScreen(isFullScreen: boolean) {
    this.isFullScreen = isFullScreen;
    setTimeout(() => {
      // Workaround to force slider to redraw
      dispatchWindowEvent('resize');
    }, 300);
  }

  private onShowSidebarRight(show: boolean) {
    this.showSidebarRight = show;
  }

  private onPointSelected(point: Point | null) {
    this.selectedPoint = point;
    setTimeout(() => {
      // Workaround to force slider to redraw
      dispatchWindowEvent('resize');
    }, 300);
  }

  private onCloseSidebar() {
    this.selectedPoint = null;
    EventBus.$emit(Config.MapClearSelectedPointsEvent);
    setTimeout(() => {
      // Workaround to force slider to redraw
      dispatchWindowEvent('resize');
    }, 300);
  }
}
